import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { ChangeDetectorRef } from '@angular/core';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { SendDocumentsModalComponent } from '../send-documents-modal/send-documents-modal.component';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { QuotationModalComponent } from '../quotation-modal/quotation-modal.component';
import { OrderPaymentComponent } from 'src/app/pages/orders/outbound/components/modals/order-payment/order-payment.component';
import { CountdownEvent } from 'ngx-countdown';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { BankChannelModalComponent } from '../bank-channel-modal/bank-channel-modal.component';
import { UpdateOrderComponent } from 'src/app/shared/modals/update-order/update-order.component';
import * as saveAs from 'file-saver';
import { NotifierService } from 'angular-notifier';
import { AuthenticationService } from 'src/app/shared/services';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { QuotationModalMobileComponent } from '../quotation-modal/quotation-modal-mobile/quotation-modal-mobile.component';

@Component({
  selector: 'app-order-details-modal',
  templateUrl: './order-details-modal.component.html',
  styleUrls: ['./order-details-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrderDetailsModalComponent implements OnInit {
  boobleModalData: any;
  rType: string = '';
  moedas = Moedas;
  currency: any;
  isMobile: boolean;
  private readonly notifier: NotifierService;

  iof: number;
  ir: number;
  commercial: number;

  get companyId() {
    return +this.authService.getCompanyId();
  }

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private bottomSheet: MatBottomSheet,
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    private ordersService: OrdersService,
    private cdr: ChangeDetectorRef
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820;
    this.rType = this.router.url.includes('0') ? '0' : '1';
    this.currency = this.moedas.find(
      (moeda) => moeda.id === this.boobleModalData.currency.id
    );

    if (this.boobleModalData.quotations?.length > 0) {
      if (this.boobleModalData.remmitanceType === 'OUTBOUND') {
        this.ir = this.boobleModalData.quotations[0].irOutbound;
        this.iof = this.boobleModalData.quotations[0].iofOutbound;
        this.commercial = Number(
          (
            this.boobleModalData.quotations[0].rate +
            this.boobleModalData.quotations[0].rate *
              this.boobleModalData.quotations[0].spread
          ).toPrecision(5)
        );
      } else if (this.boobleModalData.remmitanceType === 'INBOUND') {
        this.ir = this.boobleModalData.quotations[0].irInbound;
        this.iof = this.boobleModalData.quotations[0].iofInboud;
        this.commercial = Number(
          (
            this.boobleModalData.quotations[0].rate -
            this.boobleModalData.quotations[0].rate *
              this.boobleModalData.quotations[0].spread
          ).toPrecision(5)
        );
      }
    }
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  calcCountdown(dueDate: string): number {
    var now = new Date();
    var countDownDate = new Date(dueDate);
    var dif = countDownDate.getTime() - now.getTime();

    if (dif < 0) {
      var Seconds_Between_Dates = 0;
    } else {
      var Seconds_from_T1_to_T2 = dif / 1000;
      var Seconds_Between_Dates: number = Math.abs(Seconds_from_T1_to_T2);
    }
    return Seconds_Between_Dates;
  }

  increasePercentage(value: number, percentage: number) {
    return value + value * percentage;
  }

  onCountdownFinished(e: CountdownEvent) {
    if (e.action == 'done') {
      this.modalService.dismiss(null);
      this.ordersService.updateOrderView();
    }
  }

  downloadAttachment(fileName: string) {
    this.ordersService.downloadOrderAttachmentByName(fileName).subscribe({
      next: (data: any) => {
        saveAs(data, fileName);
        this.notifier.notify(
          'success',
          'Download do arquivo realizado com sucesso.'
        );
      },
      error: (err) => {
        this.notifier.notify('error', 'Erro ao efetuar o download do arquivo.');
      },
    });
  }

  openBankChannelModal(currencyDescription: string) {
    this.modalService.present(BankChannelModalComponent, currencyDescription);
  }

  openUpdateOrderModal(order: InboundOrderDto) {
    this.modalService.present(UpdateOrderComponent, order);
  }

  getIr(rate: number, spread: number, taxIr: number, ptax: number) {
    const residualIr =
      ((this.increasePercentage(rate, spread) < ptax
        ? ptax
        : this.increasePercentage(rate, spread)) *
        this.boobleModalData.amount) /
      (1 - taxIr);
    return residualIr * taxIr;
  }

  openQuotationModal(order: InboundOrderDto) {
    this.modalService.dismiss(null);

    if (!this.isMobile) {
      const data = {
        order: order,
        orderType: order.remmitanceType === 'OUTBOUND' ? 1 : 0,
        finality: order.finality,
        amount: order.amount,
        country:
          order.remmitanceType === 'OUTBOUND'
            ? order?.receiver?.country
            : order?.sender?.country,
        orderId: order.id,
        currency: this.moedas.find((moeda) => moeda.id === order.currency.id),
      };
      this.modalService.present(QuotationModalComponent, data);
    } else {
      const bottomSheetConfig = {
        data: {
          order: order,
          orderType: order.remmitanceType === 'OUTBOUND' ? 1 : 0,
          finality: order.finality,
          amount: order.amount,
          country:
            order.remmitanceType === 'OUTBOUND'
              ? order?.receiver?.country
              : order?.sender?.country,
          orderId: order.id,
          currency: this.moedas.find((moeda) => moeda.id === order.currency.id),
        },
      };
      this.bottomSheet.open(QuotationModalMobileComponent, bottomSheetConfig);
    }
  }

  openOrderPaymentModal(order: InboundOrderDto) {
    this.modalService.present(OrderPaymentComponent, order);
  }

  openSendDocumentsModal(order: InboundOrderDto) {
    this.modalService.dismiss(null);
    this.modalService.present(SendDocumentsModalComponent, order);
  }
}
